import type { TypedMutationOnQueryStarted } from '@reduxjs/toolkit/query'
import { board as baseBoard } from './baseApi/board'
import type {
  PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiArg,
  PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiResponse,
} from './baseApi/board'
import type { baseQuery } from './baseQuery'

export type * from './baseApi/board'

export const onPutResponsibilityStarted: TypedMutationOnQueryStarted<
  PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiResponse,
  PutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityApiArg,
  typeof baseQuery,
  'portal'
> = async (
  { groupId, assignmentId, selectiongroupResponsibilityUpdateModel },
  { dispatch, queryFulfilled }
) => {
  const patch = dispatch(
    baseBoard.util.updateQueryData(
      'getBoardsByIdMembers',
      { id: groupId },
      (draft) => {
        const member = draft.find((x) => x.assignmentId === assignmentId)
        if (member)
          member.responsibility =
            selectiongroupResponsibilityUpdateModel.responsibility
      }
    )
  )

  try {
    await queryFulfilled
  } catch {
    patch.undo()
  }
}

export const boardApi = baseBoard.enhanceEndpoints({
  endpoints: {
    putBoardsByGroupIdAssignmentAndAssignmentIdResponsibility: {
      onQueryStarted: onPutResponsibilityStarted,
    },
  },
})

export const {
  useGetBoardsQuery,
  useGetBoardsByGroupIdQuery,
  useGetBoardsByIdMembersQuery,
  useGetBoardsByIdAnnualcycleQuery,
  usePutBoardsByGroupIdAssignmentAndAssignmentIdResponsibilityMutation,
  useGetBoardsByClientIdBoardmembersQuery,
} = boardApi
